import { type WatchlistApproverConstructor } from '@webapp/modules/purchasing/entities/WatchlistApprover'
import { type WatchlistApproverApiModel } from '../api-models/WatchlistApproverApiModel'

export const mapWatchlistApproverApiModel = (
  raw: WatchlistApproverApiModel
): WatchlistApproverConstructor => ({
  id: raw.approver.id,
  firstName: raw.approver.firstName,
  lastName: raw.approver.lastName,
  approvalCount: raw.count,
  delegateeName: raw.approver.approval_delegatee
    ? `${raw.approver.approval_delegatee.firstName} ${raw.approver.approval_delegatee.lastName}`
    : null,
})
